import React, { useMemo, useState } from "react";
import NewSearch from "../../components/Desktop/NewSearch";
import { ReactComponent as Chatbot } from "../../icons/Chatbot.svg";
import { ReactComponent as ArrowRight } from "../../icons/RightArrow.svg";
import { ReactComponent as Staff } from "../../icons/Staff.svg";
// import {
//   useCompleteSignIn,
//   useLoadAccountMemberships,
// } from "../../hooks/authhooks";
import { CommunitySchema, MembershipSchema } from "../../data/types";
import { filterMessageMemberships } from "../../utils/helpers";

const capitalizeString = (string: string) =>
  string?.replace(/\w/, (c) => c?.toUpperCase());

type UserListWindowProps = {
  username: string;
  accountMemberships: MembershipSchema[];
  choosingChat: boolean;
  setChoosingChat: () => void;
  selectedChat: string;
  setSelectedChat: React.Dispatch<React.SetStateAction<string>>;
  selectedCommunity?: CommunitySchema;
  setSelectedCommunity?: React.Dispatch<React.SetStateAction<CommunitySchema | undefined>>;
};

const UserListWindow: React.FC<UserListWindowProps> = ({
  username,
  accountMemberships,
  setChoosingChat,
  setSelectedChat,
  setSelectedCommunity,
}) => {
  const [searchTerm, changeSearchTerm] = useState("");
  const [filterSetting, setFilterSetting] = useState<boolean>(false);

  // const { user } = useCompleteSignIn();
  // const loggedin_username = user && user?.username ? user.username : "";
  // const { accountMemberships } = useLoadAccountMemberships(loggedin_username);

  const toggleFilterSetting = () => {
    setFilterSetting(!filterSetting);
  };

  const filteredMemberships = useMemo(
    () => filterMessageMemberships(accountMemberships ?? [], searchTerm),
    [accountMemberships, searchTerm]
  );

  const useFixedChatListHeight =
    (accountMemberships?.length ?? 0) > 1 || filteredMemberships.length > 1;

  return (
    <div className="">
      <div className="flex flex-row z-0 p-2">
        <NewSearch
          searchTerm={searchTerm}
          toggleFilterSetting={toggleFilterSetting}
          filterSetting={filterSetting}
          changeSearchTerm={changeSearchTerm}
          searchType="messages"
        />
      </div>

      <div
        className={`flex flex-col gap-3 p-1 ${
          useFixedChatListHeight ? "h-[288px] flex-shrink-0 overflow-y-auto" : ""
        }`}
      >
        <ChatUser
          currentChatCommunity="chatbot"
          member={username}
          allThreadsByCommunity={""}
          setSelectedChat={setSelectedChat}
          setMessageOpen={() => setChoosingChat()}
        />
        <ChatUser
          currentChatCommunity="staff"
          member={username}
          allThreadsByCommunity={""}
          setSelectedChat={setSelectedChat}
          setMessageOpen={() => setChoosingChat()}
        />
        {filteredMemberships.map((membership: MembershipSchema, index: number) => (
            <ChatUser
              key={membership.community_id || membership.id || index}
                currentChatCommunity={membership.community_id || membership.id || ""}
              member={membership.username || ""}
              membership={membership}
              allThreadsByCommunity={""}
              setSelectedChat={setSelectedChat}
              setSelectedCommunity={setSelectedCommunity}
              setMessageOpen={() => setChoosingChat()}
            />
          ))}
      </div>
    </div>
  );
};

type ChatUserProps = {
  member: string;
  currentChatCommunity: string;
  membership?: MembershipSchema;
  setSelectedChat: React.Dispatch<React.SetStateAction<string>>;
  setSelectedCommunity?: React.Dispatch<React.SetStateAction<CommunitySchema | undefined>>;
  allThreadsByCommunity: any;
  setMessageOpen: any;
};

const ChatUser: React.FC<ChatUserProps> = ({
  member,
  membership,
  currentChatCommunity,
  setSelectedChat,
  setSelectedCommunity,
  setMessageOpen,
}) => {
  const handleClick = () => {
    if (setSelectedChat) {
      setSelectedChat(currentChatCommunity);
    }
    if (setSelectedCommunity) {
      setSelectedCommunity(membership);
    }
    setMessageOpen();
  };

  const get_primary_text = (member: string) => {
    return (
      <p className="font-raleway font-semibold text-[14px] text-[#2D3748]">
        {member === "chatbot" ? capitalizeString(member) : member}
      </p>
    );
  };

  const get_secondary_text = (message: string) => {
    return (
      <p className="text-[#4D4D4D] font-open-sans font-normal text-[12px]">
        <>
          <span>{message}</span>
        </>
      </p>
    );
  };

  if (currentChatCommunity !== "chatbot") {
    return (
      <div
        style={{ backgroundColor: "#fff" }}
        className={`flex  m-1 p-5 cursor-pointer h-[80px] rounded-[8px] border-[1px] border-[#E9E9E9] hover:border-[#51a0b5] transition-all duration-200 justify-between`}
        onClick={() => {
          handleClick();
        }}
      >
        <div className="flex flex-row">
          { membership? <img src={membership.logo} alt={membership.name} className="rounded-full h-[40px] w-[40px] object-scale-down"></img> :
            <Staff
              className={`h-[40px] w-[40px] text-primaryDark-0/90`}
            />
          }{" "}
          <div className="flex flex-col mx-4">
            <div>{get_primary_text(membership?.name || "Chat with a staff member")}</div>
            <div>{get_secondary_text("Start a conversation")}</div>
          </div>
        </div>
        <ArrowRight className="my-auto" />
      </div>
    );
  } else {
    return (
      <div
        style={{ backgroundColor: "#fff" }}
        className={`flex justify-between m-1 p-5 cursor-pointer h-[80px] rounded-[8px] border-[1px] border-[#E9E9E9] hover:border-[#51a0b5] transition-all duration-200`}
        onClick={() => {
          handleClick();
        }}
      >
        <div className="flex flex-row">
          <Chatbot className={`h-[40px] w-[40px] text-primaryDark-0/90`} />
          <div className="flex flex-col mx-4">
            <div>{get_primary_text("Chat with AI Assistant")}</div>
            <div>{get_secondary_text("Start a conversation")}</div>
          </div>
        </div>
        <ArrowRight className="my-auto" />
      </div>
    );
  }
};

export default UserListWindow;
